import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'srcset'
})
export class SrcsetPipe implements PipeTransform {
  transform(src: string | { url: string; type: string; }[] | undefined, sizes: string[]): string {
    if (typeof src !== 'string') return '';

    const regex = /_(\d+)x(\d+)x(\d+)\.jpg/;
    const match = src.match(regex);

    if (!match) return '';

    const originalWidth = parseInt(match[1], 10);
    const originalHeight = parseInt(match[2], 10);
    const ratio = originalWidth / originalHeight;

    const baseUrl = src.split('?')[0];
    const query = src.includes('?') ? '?' + src.split('?')[1] : '';

    return sizes
      .map(sizeStr => {
        const width = parseInt(sizeStr, 10);
        const height = Math.round(width / ratio);
        const newUrl = baseUrl.replace(regex, `_${width}x${height}x100.jpg`);
        return `${newUrl}${query} ${width}w`;
      })
      .join(', ');
  }
}